export default "__VITE_ASSET__536b1c07__"